import React from "react";

export default function Settings() {
  return (
    <div className="p-8">
      <h2 className="text-2xl font-bold mb-4">Setări / Settings</h2>
      <p className="text-gray-400 text-sm">
        Limba se poate schimba din colțul din dreapta sus al aplicației.
      </p>
    </div>
  );
}
